import {useSelector} from 'react-redux';
import {selectAdditionalQueries} from 'hsi/selectors';

export default function useIsMultipleSearch() {
    return useSelector(selectAdditionalQueries)?.length > 0;
}
